import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "modal fade modal-lg-fullscreen-fix",
  ref: "modalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-focus": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px modal-fullscreen-lg-down" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header justify-content-start",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left fs-2x" })
  ])
], -1)
const _hoisted_6 = { class: "ms-2" }
const _hoisted_7 = { class: "modal-body p-5 px-lg-17" }
const _hoisted_8 = { class: "pb-5" }
const _hoisted_9 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_10 = { class: "form-floating mb-5" }
const _hoisted_11 = {
  disabled: "",
  value: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-label mb-3 required" }
const _hoisted_14 = { class: "form-floating mb-5" }
const _hoisted_15 = { class: "form-label mb-3 required" }
const _hoisted_16 = { class: "form-floating mb-5" }
const _hoisted_17 = { class: "form-label mb-3 required" }
const _hoisted_18 = { class: "input-group mb-5" }
const _hoisted_19 = { class: "form-floating flex-grow-1" }
const _hoisted_20 = { class: "form-label mb-3 required" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fs-2x" })
], -1)
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_address_submit",
  class: "btn btn-primary"
}
const _hoisted_24 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_FlatPickr = _resolveComponent("FlatPickr")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("menoresModalDatosMenorLabel")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                name: "tratamiento",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event)),
                class: "form-select form-select-solid"
              }, [
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("OpcionInicialTratamiento")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: tratamiento.id,
                    key: i
                  }, _toDisplayString(tratamiento.text), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.tratamiento]
              ]),
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("TratamientoLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "tratamiento",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                name: "nombre",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event)),
                type: "text",
                class: "form-control form-control-lg form-control-solid",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.nombre]
              ]),
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("menoresModalNombreLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "nombre",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                name: "apellidos",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event)),
                type: "text",
                class: "form-control form-control-lg form-control-solid",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.apellidos]
              ]),
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("menoresModalApellidosLabel")), 1),
              _createVNode(_component_ErrorMessage, {
                name: "apellidos",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FlatPickr, {
                  config: _ctx.configFechaNacimiento,
                  name: "fechaNacimiento",
                  modelValue: _ctx.fechaNacimiento,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fechaNacimiento) = $event)),
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: " ",
                  autocomplete: "off"
                }, null, 8, ["config", "modelValue"]),
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("menoresModalFechaNacimientoLabel")), 1)
              ]),
              _hoisted_21,
              _createVNode(_component_ErrorMessage, {
                name: "fechaNacimiento",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("menoresModaleGuardarBtn")), 1)
            ], 512)
          ])
        ], 32)
      ])
    ])
  ], 512))
}